import { AbstractControl } from '@angular/forms';

/**
 * Verrouille un formulaire (et tous ses contrôles) quand l'utilisateur n'a pas le droit de
 * modification : les règles métier locales (statut, contact d'engagement…) ne peuvent pas rouvrir
 * un champ à un utilisateur en lecture seule. À appeler après chaque (ré)initialisation du formulaire.
 */
export function lockFormWhenReadOnly(form: AbstractControl | null | undefined, isReadOnly: boolean): void {
  if (isReadOnly && form) {
    form.disable({ emitEvent: false });
  }
}

/**
 * Réactive un contrôle au fil des règles métier (statut, valeurs saisies…) uniquement si l'utilisateur
 * a le droit de modifier : en lecture seule, le contrôle reste verrouillé quoi qu'il arrive.
 */
export function enableControlWhenAllowed(
  form: { get(path: string): AbstractControl | null } | null | undefined,
  controlName: string,
  isReadOnly: boolean,
): void {
  if (!isReadOnly) {
    form?.get(controlName)?.enable({ emitEvent: false });
  }
}
